import React from "react"
import { useNavigate } from "react-router-dom"

import * as Commands from "../../../../model/commands"
import { Idea } from "../../../../model/types"
import { generatePublicId } from "../../../../model/public_id"
import { HelpBubble } from "../../../components/help_bubble"
import { useNana } from "../../../hooks/useNana"

import ShowEditor from "../mosaic_page/idea_pane/show_editor"

import Hub from "../../../../hub"
import { MosaicPageState } from "../mosaic"

const CaptureEditorState: { content: string } = {
  content: "<p></p>",
}

export default function CaptureEditor({}: {}) {
  const { commander } = useNana()
  const navigate = useNavigate()
  const [tick, setTick] = React.useState(0)

  const createFleetingIdea = () => {
    if (CaptureEditorState.content == "<p></p>") return
    const id = generatePublicId()
    commander.exec(
      new Commands.CreateFleetingIdeaCommand({
        id,
        fleetingIdea: {
          id,
          content: CaptureEditorState.content,
          createdAt: new Date(),
        },
      })
    )
    CaptureEditorState.content = "<p></p>"
    setTick((tick) => tick + 1)
  }

  return (
    <>
      <form
        className="flex flex-col gap-4"
        onSubmit={(e) => {
          e.preventDefault()
          createFleetingIdea()
        }}
      >
        <div className="min-h-0 max-h-80 md:max-h-168 flex flex-col justify-start bg-white dark:bg-gray-800 shadow">
          <ShowEditor
            objectKey={tick}
            initialContent={CaptureEditorState.content}
            initialScrollTop={0}
            placeholderText="Capture note to place in the mosaic later..."
            onPageLinkClick={(idea: Idea) => {
              MosaicPageState.forceOpenLocation = idea.location
              navigate("/app")
            }}
            onUpdate={(newContent, _newSelectionPos) => {
              CaptureEditorState.content = newContent
            }}
            onKeyDown={(event: KeyboardEvent) => {
              if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
                event.preventDefault()
                createFleetingIdea()
              }
            }}
            onScroll={(scrollTop: number) => {}}
            recreateWhen={(hub: Hub, recreate): string[] => {
              return []
            }}
          />
        </div>
        <div className="flex-shrink-0 flex justify-between items-center">
          <button
            type="submit"
            className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-500"
          >
            Capture
          </button>
          <HelpBubble title="Capturing quick ideas">
            <HelpCapturePage />
          </HelpBubble>
        </div>
      </form>
    </>
  )
}

const HelpCapturePage = () => {
  return (
    <>
      <p>
        Use this page to capture ideas rapidly. They should be short - just something to jog your
        memory.
      </p>
      <p>
        Later, take them from here and place them into the Mosaic, and rewrite them fully into
        permanent notes.
      </p>
    </>
  )
}
